// 34 Indonesian provinces data
export const PROVINSI = [
  { name: "Aceh", capital: "Banda Aceh", emoji: "🕌" },
  { name: "Sumatera Utara", capital: "Medan", emoji: "🦏" },
  { name: "Sumatera Barat", capital: "Padang", emoji: "🍛" },
  { name: "Riau", capital: "Pekanbaru", emoji: "🌴" },
  { name: "Kepulauan Riau", capital: "Tanjung Pinang", emoji: "🏝️" },
  { name: "Jambi", capital: "Jambi", emoji: "🐘" },
  { name: "Sumatera Selatan", capital: "Palembang", emoji: "🍤" },
  { name: "Bengkulu", capital: "Bengkulu", emoji: "🌺" },
  { name: "Lampung", capital: "Bandar Lampung", emoji: "🐯" },
  { name: "Bangka Belitung", capital: "Pangkal Pinang", emoji: "⛏️" },
  { name: "DKI Jakarta", capital: "Jakarta", emoji: "🏙️" },
  { name: "Jawa Barat", capital: "Bandung", emoji: "🏔️" },
  { name: "Banten", capital: "Serang", emoji: "🌊" },
  { name: "Jawa Tengah", capital: "Semarang", emoji: "🏯" },
  { name: "DI Yogyakarta", capital: "Yogyakarta", emoji: "🏰" },
  { name: "Jawa Timur", capital: "Surabaya", emoji: "🌋" },
  { name: "Bali", capital: "Denpasar", emoji: "🌺" },
  { name: "Nusa Tenggara Barat", capital: "Mataram", emoji: "🏝️" },
  { name: "Nusa Tenggara Timur", capital: "Kupang", emoji: "🐉" },
  { name: "Kalimantan Barat", capital: "Pontianak", emoji: "🌳" },
  { name: "Kalimantan Tengah", capital: "Palangkaraya", emoji: "🦧" },
  { name: "Kalimantan Selatan", capital: "Banjarmasin", emoji: "💎" },
  { name: "Kalimantan Timur", capital: "Samarinda", emoji: "🛢️" },
  { name: "Kalimantan Utara", capital: "Tanjung Selor", emoji: "🌲" },
  { name: "Sulawesi Utara", capital: "Manado", emoji: "🐡" },
  { name: "Gorontalo", capital: "Gorontalo", emoji: "🌾" },
  { name: "Sulawesi Tengah", capital: "Palu", emoji: "🏞️" },
  { name: "Sulawesi Barat", capital: "Mamuju", emoji: "🌊" },
  { name: "Sulawesi Selatan", capital: "Makassar", emoji: "⛵" },
  { name: "Sulawesi Tenggara", capital: "Kendari", emoji: "🦋" },
  { name: "Maluku", capital: "Ambon", emoji: "🌶️" },
  { name: "Maluku Utara", capital: "Sofifi", emoji: "🌋" },
  { name: "Papua", capital: "Jayapura", emoji: "🦜" },
  { name: "Papua Barat", capital: "Manokwari", emoji: "🐚" },
];

// 25 Indonesian national heroes
export const PAHLAWAN = [
  { name: "Soekarno", role: "Presiden Pertama", desc: "Memproklamasikan Kemerdekaan Indonesia 17 Agustus 1945" },
  { name: "Mohammad Hatta", role: "Wakil Presiden Pertama", desc: "Bapak Koperasi Indonesia" },
  { name: "Kartini", role: "Pelopor Emansipasi Wanita", desc: "Penulis buku 'Habis Gelap Terbitlah Terang'" },
  { name: "Cut Nyak Dien", role: "Pejuang Wanita Aceh", desc: "Pemimpin perang gerilya melawan Belanda" },
  { name: "Diponegoro", role: "Pangeran Jawa", desc: "Memimpin Perang Jawa 1825-1830" },
  { name: "Sudirman", role: "Jenderal Besar", desc: "Panglima TNI pertama, bergerilya melawan Belanda" },
  { name: "Bung Tomo", role: "Pejuang Surabaya", desc: "Pemimpin pertempuran 10 November 1945" },
  { name: "Imam Bonjol", role: "Pejuang Sumatera Barat", desc: "Memimpin Perang Padri" },
  { name: "Pattimura", role: "Pejuang Maluku", desc: "Memimpin perlawanan di Saparua" },
  { name: "Hasanuddin", role: "Sultan Makassar", desc: "Dijuluki 'Ayam Jantan dari Timur'" },
  { name: "Ki Hajar Dewantara", role: "Bapak Pendidikan", desc: "Pendiri Taman Siswa" },
  { name: "Tjut Meutia", role: "Pejuang Aceh", desc: "Pejuang wanita penerus Cut Nyak Dien" },
  { name: "Dewi Sartika", role: "Tokoh Pendidikan Wanita", desc: "Pendiri sekolah perempuan di Bandung" },
  { name: "Untung Surapati", role: "Pejuang Anti-VOC", desc: "Pemimpin perlawanan di Jawa Timur" },
  { name: "Tuanku Tambusai", role: "Pejuang Sumatera", desc: "Pemimpin Perang Padri" },
  { name: "Sultan Agung", role: "Raja Mataram", desc: "Menyerang Batavia 1628-1629" },
  { name: "Mahaputra Yamin", role: "Pendiri Bangsa", desc: "Pemikir Sumpah Pemuda 1928" },
  { name: "Sutomo", role: "Pendiri Budi Utomo", desc: "Pelopor organisasi pemuda modern 1908" },
  { name: "Wahidin Sudirohusodo", role: "Tokoh Budi Utomo", desc: "Penggagas pendidikan untuk pribumi" },
  { name: "Teuku Umar", role: "Pejuang Aceh", desc: "Suami Cut Nyak Dien, pejuang gerilya" },
  { name: "Gajah Mada", role: "Mahapatih Majapahit", desc: "Sumpah Palapa menyatukan Nusantara" },
  { name: "Hayam Wuruk", role: "Raja Majapahit", desc: "Membawa Majapahit ke puncak kejayaan" },
  { name: "Cut Meurah Intan", role: "Pejuang Aceh", desc: "Pejuang wanita melawan Belanda" },
  { name: "Sisingamangaraja XII", role: "Raja Batak", desc: "Pejuang Tanah Batak Sumatera Utara" },
  { name: "Pangeran Antasari", role: "Pejuang Kalimantan", desc: "Memimpin Perang Banjar" },
];
